import React from 'react';
import { AppMultiSelectDropdown } from '../../components/AppMultiSelectDropdown';
import { AppSelectDropdown } from '../../components/AppSelectDropdown';
import { SETTINGS_FIELD_LABEL, SETTINGS_SELECT_TRIGGER_CLASS } from '../settings/utils/settingsSectionStyles';

export type AiVisibility = 'private' | 'members' | 'instance';

export type AiShareMember = { value: string; label: string };

const VISIBILITY_OPTIONS = [
  { value: 'private', label: 'Nur ich' },
  { value: 'members', label: 'Bestimmte Personen' },
  { value: 'instance', label: 'Ganze Instanz' },
];

export function useAiShareMembers(): AiShareMember[] {
  const [members, setMembers] = React.useState<AiShareMember[]>([]);
  React.useEffect(() => {
    let cancelled = false;
    fetch('/api/me', { credentials: 'include' })
      .then((res) => res.ok ? res.json() as Promise<{ user?: { id?: string } }> : null)
      .then(async (me) => {
        const memberRes = await fetch('/api/me/members', { credentials: 'include' });
        if (!memberRes.ok) return [];
        const body = await memberRes.json() as { members?: Array<{ user_id: string; display_name: string | null; email: string; invited?: boolean }> };
        const selfId = me?.user?.id;
        return (body.members ?? [])
          .filter((member) => !member.invited && member.user_id !== selfId)
          .map((member) => ({ value: member.user_id, label: member.display_name?.trim() || member.email }));
      })
      .then((next) => { if (!cancelled && next) setMembers(next); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, []);
  return members;
}

export function AiShareFields({
  idPrefix,
  visibility,
  onVisibilityChange,
  granteeUserIds,
  onGranteesChange,
  members,
}: {
  idPrefix: string;
  visibility: AiVisibility;
  onVisibilityChange: (value: AiVisibility) => void;
  granteeUserIds: string[];
  onGranteesChange: (ids: string[]) => void;
  members: AiShareMember[];
}) {
  return (
    <div className="space-y-3">
      <div>
        <label htmlFor={`${idPrefix}-visibility`} className={SETTINGS_FIELD_LABEL}>Sichtbarkeit</label>
        <AppSelectDropdown
          id={`${idPrefix}-visibility`}
          value={visibility}
          onChange={(value) => onVisibilityChange(value as AiVisibility)}
          options={VISIBILITY_OPTIONS}
          triggerClassName={SETTINGS_SELECT_TRIGGER_CLASS}
          className="mt-1.5"
        />
      </div>
      {visibility === 'members' ? (
        <AppMultiSelectDropdown
          label="Personen"
          variant="form"
          placeholder="Personen wählen"
          selected={granteeUserIds}
          onChange={onGranteesChange}
          options={members}
          emptyLabel="Keine weiteren Personen"
          className="w-full"
          menuZIndex={10120}
        />
      ) : null}
    </div>
  );
}
